module.exports = __webpack_public_path__ + "img/benefits.b65f9503.png";